module.exports = __webpack_public_path__ + "static/img/no.93a89ef2.svg";